import cx from 'classnames';
import React from 'react';

import colors from 'utils/colors';
import * as Styling from 'utils/styled';

import * as Elements from './Elements';
import { IconProps } from './interfaces';

const Clock: React.FC<IconProps> = ({
  className = '',
  fill = colors.blueGrey,
  viewBox = '0 0 67 65',
  d = 'M64.12 17.44A10.34 10.34 0 0 0 67 10.26 10.16 10.16 0 0 0 57 0a9.9 9.9 0 0 0-7 2.94zm-61.24 0A10.34 10.34 0 0 1 0 10.26 10.16 10.16 0 0 1 10 0a9.9 9.9 0 0 1 7 2.94zm30.62-14C16.88 3.42 3.35 17.23 3.35 34.21S16.88 65 33.5 65s30.15-13.81 30.15-30.79S50.12 3.42 33.5 3.42zm7.68 43.47l-10-10.26a3.45 3.45 0 0 1-1-2.42V17.1h6.7v15.69l9.07 9.26z',
  transition = 'fill 0.1s ease-in-out',
  cssHelper = Styling.fullHeightStyle,
  focusable
}) => {
  return (
    <Elements.Svg
      viewBox={viewBox}
      className={cx({ [className]: !!className })}
      cssHelper={cssHelper}
      focusable={!!focusable}
      aria-hidden={!focusable}>
      <Elements.Path fill={fill} d={d} transition={transition} />
    </Elements.Svg>
  );
};

export default Clock;
